export const CVR_LENGTH = 8
